import { render } from "./CardFooter.vue?vue&type=template&id=880ada6c&scoped=true&ts=true"
import script from "./CardFooter.vue?vue&type=script&lang=ts"
export * from "./CardFooter.vue?vue&type=script&lang=ts"

import "./CardFooter.vue?vue&type=style&index=0&id=880ada6c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880ada6c"]])

export default __exports__